import axios from '../helpers/axiosConfig';
import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Pagination from './Pagination/Pagination'; // Assurez-vous que le chemin est correct
import PersonnelAnniversaires from './PersonnelAnniversaires';
import SearchForm from './SearchForm';
import { AuthContext } from '../helpers/AuthContext';
import axiosInstance from '../helpers/axiosErrorServer';
import { toast } from 'react-toastify'; // Importation

import getBaseUrl from '../helpers/utility';

function Personnel() {
  const baseUrl = getBaseUrl();

  let navigate = useNavigate();
  const location = useLocation(); // Utiliser useLocation pour accéder à l'emplacement

  const { authState } = useContext(AuthContext);
  const [personnels, setPersonnels] = useState([]);

  const [personnelsPerPage] = useState(50); // Nombre de personnels par page
  const [currentPage, setCurrentPage] = useState(1);

  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const [stats, setStats] = useState(null);

  const query = new URLSearchParams(location.search); // Utiliser location.search pour récupérer la chaîne de requête
  let token = localStorage.getItem('accessToken');

  const nomprenom = query.get('nomprenom');


  useEffect(() => {

    if (!token) {
      navigate("/login");
      return;
    }


    const interval = setInterval(() => {
      setProgress((prev) => (prev < 97 ? prev + 1 : prev));
    }, 100);

    const fetchPersonnels = async () => {
      try {
        const response = await axios.get('/personnel/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setPersonnels(response.data.personnels);
        setStats(response.data.stats);
        setLoading(false);
        clearInterval(interval);
        setProgress(100);

      } catch (err) {
        console.error("Erreur Axios :", err);
        setLoading(false);
        clearInterval(interval);

        if (err.response) {
          const { status, data } = err.response;
          const errorMessage = data?.message || data?.error || "Erreur inconnue";

          console.error("Erreur status :", status);
          console.error("Détails erreur serveur :", data);

          // ✅ Redirection en cas de token invalide
          if (status === 403 && errorMessage === "Invalid Token") {
            toast.error("Veuillez entrer votre login et mot de passe.");
            localStorage.removeItem("token");
            navigate("/login");
            return;
          }

          // ✅ Affiche le message d'erreur du backend directement (pas besoin de le dupliquer dans le frontend)
          toast.error(errorMessage);

        } else {
          console.error("Erreur sans réponse :", err.message);
          toast.error("Erreur de connexion au serveur");
        }
      }
    };

    fetchPersonnels();
  }, [location.key]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        await axios
          .get(`personnel?nomprenom=${nomprenom}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            setPersonnels(response.data);
          })
          .catch((err) => {
            toast.error(err.message);
          });
      } catch (err) {
        toast.error(`Erreur lors de la récupération des personnels ${err.response?.data?.error}`);
      }
    };

    if (nomprenom) {
      fetchData();
    }
  }, [nomprenom]);

  const deletePersonnel = async (id) => {
    const confirmDeletion = async () => {
      await axios
        .delete(`personnel/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          toast.success(response.data.message);
        })
        .then(() => setPersonnels(personnels.filter((personnel) => personnel.id !== id)))
        .catch((error) => toast.error(error.response.data.error));
    };
    const confirmToast = toast(
      <div>
        <p>Êtes-vous sûr de vouloir supprimer ce personnel ?</p>
        <button className="btn-info float-left " onClick={cancelDeletion}>
          Non
        </button>
        <button className="btn-danger float-right " onClick={confirmDeletion}>
          Oui
        </button>
      </div>,
      {
        autoClose: 3000,
        closeOnClick: false,
      }
    );
    function cancelDeletion() {
      toast.info('Suppression annulée.');
    }
  };

  // Calculer les indices de personnels pour la page actuelle
  const indexOfLastPersonnel = currentPage * personnelsPerPage;
  const indexOfFirstPersonnel = indexOfLastPersonnel - personnelsPerPage;
  const currentPersonnels = personnels.slice(indexOfFirstPersonnel, indexOfLastPersonnel);

  // Changer de page
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(personnels.length / personnelsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const getGrade = (personnel) => {
    switch (personnel.arme) {
      case 'AIR':
        return personnel.grade?.gradeair;
      case 'MER':
        return personnel.grade?.grademer;
      default:
        return personnel.grade?.name;
    }
  };

  const handleExportExcel = async () => {
    toast.info('Exportation en cours');
    try {
      console.log("Token avant fetch :", token);
      console.log("URL Axios :", axios.defaults.baseURL + '/personnel/');
      const response = await axios.get('/personnel/export/link/X/2', {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'personnels_en_service.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('QRCode générer avec succés');
    } catch (error) {
      toast.error(`Erreur lors de l'exportation du fichier Excel : ${error.response.data.error}`);
    }
  };

  /* useEffect(() => {
    axios.get('personnel/statistiques/222', {
      headers: {
        Authorization: `Bearer ${token}`, // Ajoute "Bearer " avant le token
      },
    })
      .then(res => {
        setStats(res.data);        
      })
      .catch(err => {
        console.error(err);
      });
  }, []); */



  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await axios.get('/personnel/liste/userslogs/253/u/c')
      setLogs(res.data);
    } catch (error) {
      console.error("Erreur lors du chargement :", error);
    }
  };

  // Fonction pour formater la date comme : 25 Mai 2025 à 15h 30mn
  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const mois = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    const jour = date.getDate();
    const moisNom = mois[date.getMonth()];
    const annee = date.getFullYear();
    const heures = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${jour} ${moisNom} ${annee} à ${heures}h ${minutes}mn`;
  };
  const isInfocomm = authState.user && (authState.user.username === 'dcca' || authState.user.username === 'colrodi');
  //console.log(authState.user);
  const brigades = [
    { id: 10, name: "Antsiranana", className: "btn btn-primary", username: "brcaantsiranana" },
    { id: 15, name: "Toamasina", className: "btn btn-secondary", username: "brcatoamasina" },
    { id: 9, name: "Mahajanga", className: "btn btn-success", username: "brcamahajanga" },
    { id: 16, name: "Manakara", className: "btn btn-danger", username: "brcamanakara" },
    { id: 13, name: "Morondava", className: "btn btn-warning", username: "brcamorondava" },
    { id: 25, name: "Taolagnaro", className: "btn btn-info", username: "brcataolagnaro" },
    { id: 14, name: "Toliara", className: "btn btn-light", username: "brcatoliara" },
    { id: 24, name: "Tsiroanomandidy", className: "btn btn-dark", username: "brcatsiroanomandidy" },
    { id: 11, name: "Antananarivo", className: "btn btn-primary", username: "brcaantananarivo" },
    { id: 12, name: "Fianarantsoa", className: "btn btn-success", username: "brcafianarantsoa" },
  ];
  const filteredBrigades =
    authState.user?.roles === "SUPERADMIN"
      ? brigades
      : brigades.filter(
        (b) => b.username === authState.user?.username
      );

  return (
    <div className="">
      <div className="col mt-4 text-center">
        <div className="d-flex  flex-wrap ">
          {filteredBrigades.map((brigade) => (
            <a
              key={brigade.id}
              href={`/brigade/${brigade.id}/effectifbrigade`}
              className={`${brigade.className} me-2 mb-2 col-md-1 mr-3`}
            >
              BRCA  {brigade.name}
            </a>
          ))}
        </div>
      </div>
      <div className="jumbotron bg-dark text-white ">
        <div className="col">
          <SearchForm setPersonnels={setPersonnels} setStats={setStats} />
        </div>
      </div>
      <div className="col">
        <div className="row">
          {/*<div className="col-md-2  ">
             <PersonnelAnniversaires /> 
          </div>*/}
          <div className="col">
            {/*             <div className="row">
              <div className="col">
                <div>

                  <button onClick={handleExportExcel} className="float-right btn btn-warning btn-sm ">
                    Exporter QR Code vers Excel
                  </button>
                </div>
              </div>
            </div> */}

            <div className="max-w-5xl mx-auto mt-10 px-4 sm:px-6">

              {/* Titre & Sous-titre */}
              <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div>
                  <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight flex items-center gap-3">
                    <span className="text-2xl">📊</span> Statistiques du Personnel
                  </h2>
                  <p className="text-slate-500 text-sm mt-1 font-medium">
                    Tableau de bord et récapitulatif en temps réel des effectifs
                  </p>
                </div>
              </div>

              {/* Carte principale */}
              <div className="bg-white rounded-3xl shadow-xl shadow-slate-100/70 border border-slate-100 overflow-hidden transition-all duration-300">

                {/* En-tête (Hero section avec dégradé moderne) */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 p-8 bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 relative overflow-hidden">
                  {/* Effet de lumière en arrière-plan */}
                  <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />

                  <div className="z-10">
                    <p className="text-indigo-200/80 text-xs font-semibold tracking-wider uppercase mb-1">
                      Effectif Global
                    </p>
                    <h3 className="text-4xl sm:text-5xl font-black text-white tracking-tight">
                      {stats ? personnels.length.toLocaleString('fr-FR') : '—'}
                    </h3>
                    <p className="text-slate-400 text-xs mt-2 flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                      Mise à jour dynamique
                    </p>
                  </div>

                  <a
                    href="/Recaptotalbrca"
                    className="z-10 inline-flex items-center gap-2 px-5 py-3 bg-white/10 hover:bg-white text-white hover:text-slate-900 border border-white/20 hover:border-white rounded-xl font-semibold text-sm shadow-sm backdrop-blur-md transition-all duration-300 transform active:scale-95"
                  >
                    <i className="fa fa-eye text-xs"></i>
                    Voir les détails
                  </a>
                </div>

                {/* Corps des statistiques */}
                <div className="p-8 bg-slate-50/50">
                  {stats ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                      {/* Carte : Personnel Militaire */}
                      <div className="group bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300">
                        <div className="flex items-center justify-between">
                          <h4 className="font-bold text-slate-700 text-sm tracking-wide uppercase">
                            Militaire (OFF/S-OFF/ADL)
                          </h4>
                          <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center group-hover:bg-indigo-600 group-hover:text-white transition-colors duration-300">
                            <i className="fa fa-shield text-lg"></i>
                          </div>
                        </div>
                        <div className="mt-6">
                          <span className="text-4xl font-black text-slate-900 tracking-tight">
                            {stats.personnel_militaire_off_s_off_adl.toLocaleString('fr-FR')}
                          </span>
                          <p className="text-xs text-slate-400 mt-1">Personnels d'active</p>
                        </div>
                      </div>

                      {/* Carte : Personnel PDL */}
                      <div className="group bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300">
                        <div className="flex items-center justify-between">
                          <h4 className="font-bold text-slate-700 text-sm tracking-wide uppercase">
                            Personnel PDL
                          </h4>
                          <div className="w-10 h-10 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center group-hover:bg-sky-600 group-hover:text-white transition-colors duration-300">
                            <i className="fa fa-users text-lg"></i>
                          </div>
                        </div>
                        <div className="mt-6">
                          <span className="text-4xl font-black text-slate-900 tracking-tight">
                            {stats.personnel_militaire_pdl.toLocaleString('fr-FR')}
                          </span>
                          <p className="text-xs text-slate-400 mt-1">Pendant la durée légale</p>
                        </div>
                      </div>

                      {/* Carte : Personnel Civil */}
                      <div className="group bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300">
                        <div className="flex items-center justify-between">
                          <h4 className="font-bold text-slate-700 text-sm tracking-wide uppercase">
                            Personnel Civil
                          </h4>
                          <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center group-hover:bg-emerald-600 group-hover:text-white transition-colors duration-300">
                            <i className="fa fa-building text-lg"></i>
                          </div>
                        </div>
                        <div className="mt-6">
                          <span className="text-4xl font-black text-slate-900 tracking-tight">
                            {stats.personnel_civil.toLocaleString('fr-FR')}
                          </span>
                          <p className="text-xs text-slate-400 mt-1">Administratifs & assimilés</p>
                        </div>
                      </div>

                    </div>
                  ) : (
                    /* Loader épuré */
                    <div className="flex flex-col items-center justify-center py-16 isolation-auto">
                      <div className="relative flex items-center justify-center">
                        <div className="w-12 h-12 rounded-full border-4 border-indigo-100 border-t-indigo-600 animate-spin"></div>
                      </div>
                      <p className="mt-4 text-sm font-medium text-slate-500 animate-pulse">
                        Analyse et chargement des données...
                      </p>
                    </div>
                  )}
                </div>

              </div>
            </div>

            {message && <div className="alert alert-success"> {message} </div>}
            {error && <div className="alert alert-success"> {error} </div>}

            {loading ? (
              <div className="progress">
                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                  {progress}% Chargement...
                </div>
              </div>
            ) : (
              <>
                <div className="row">
                  <div className="col">
                    <Link to="/createpersonnel" className="btn btn-warning btn-sm mt-4 ">
                      Ajouter un nouveau personnel
                    </Link>
                  </div>
                </div>
                <hr />
                <div><h1>Liste des Personnels </h1></div>

                <div className="row">
                  <div className="col">
                    <table className="table table-striped table-sm">
                      <thead className="thead-dark">
                        <tr>
                          <th>#</th>
                          <th>Grade</th>
                          <th style={{ width: '9cm' }} >NOM et prénom</th>
                          <th style={{ width: '9cm' }} >Fonction</th>
                          <th>Ets ou Service</th>
                          <th>matricule</th>
                          <th>Bataillon</th>
                          <th>Compagnie</th>
                          <th>Images</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPersonnels.map((personnel, key) => (
                          <tr key={personnel.id} className="animate__animated animate__flash">
                            <td>{key + 1} </td>
                            <td> {getGrade(personnel)} </td>
                            <td> {personnel.nomprenom} </td>
                            <td> {personnel.fonction} </td>
                            <td>{personnel.etsouservice && personnel.etsouservice.name}</td>
                            <td> {personnel.matricule} </td>
                            <td>{personnel.compagnie && personnel.compagnie.bataillon.name}</td>
                            <td>{personnel.compagnie && personnel.compagnie.name}</td>

                            <td>{personnel.filename ? <img src={`${baseUrl}/images/personnels/${personnel.filename}`} width="50px" height="50px" alt="" /> : <img src={` ${baseUrl}/images/personnels/defaultImage.jpg`} width="50px" height="50px" alt="" />}</td>

                            <td className="col-md-1">
                              <i style={{ cursor: 'pointer' }} className="fa fa-eye mr-2" onClick={() => navigate(`/personnel/${personnel.id}`)}></i>
                              <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2 mr-2" onClick={() => navigate(`/personnel/edit/${personnel.id}`)}></i>
                              <i
                                style={{ cursor: 'pointer' }}
                                className="fa fa-trash"
                                onClick={() => deletePersonnel(personnel.id)}
                              ></i>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <Pagination personnelsPerPage={personnelsPerPage} totalPersonnels={personnels.length} paginate={paginate} currentPage={currentPage} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>


      {/* {isInfocomm && (
        <div className='container '>
          <h3 className="text-center mb-4">
            📋 Historique des enregistrements (Equipe INFOCOMM)
          </h3>

          <table className="table table-striped table-bordered">
            <thead className="table-dark text-center">
              <tr>
                <th>#</th>
                <th>Prénoms</th>
                <th>Bataillon</th>
                <th>Nombre de personnel</th>
                <th>Date d’enregistrement</th>
              </tr>
            </thead>
            <tbody>
              {logs.length > 0 ? (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td className="text-center">{log.id}</td>
                    <td>{log.user?.username || "—"}</td>
                    <td>{log.bataillon?.name || "—"}</td>
                    <td className="text-center">{log.nombrePersonnel}</td>
                    <td>{formatDate(log.dateEnregistrement)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    Aucun log enregistré.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )} */}

      {/*   <div className="container mt-4">
        <h3 className="text-center mb-4">📋 Historique des enregistrements (Equipe INFOCOMM)</h3>
        <table className="table table-striped table-bordered">
          <thead className="table-dark text-center">
            <tr>
              <th>#</th>
              <th>Prénoms</th>
              <th>Bataillon</th>
              <th>Nombre de personnel</th>
              <th>Date d’enregistrement</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <tr key={log.id}>
                  <td className="text-center">{log.id}</td>
                  <td>{log.user?.username || "—"}</td>
                  <td>{log.bataillon?.name || "—"}</td>
                  <td className="text-center">{log.nombrePersonnel}</td>
                  <td>{formatDate(log.dateEnregistrement)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  Aucun log enregistré.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
 */}

      {/* {authState.user.username === 'dcca' || authState.user.username === 'colrodi' ? (
        
      ) : (
        ''
      )}
 */}


    </div>
  );
}

export default Personnel;
